// src/ImageLightbox.js
import { useState } from "react";

export default function ImageLightbox({ src, alt }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <img
                src={src}
                alt={alt}
                loading="lazy"
                onClick={() => setIsOpen(true)}
                style={{ cursor: "pointer" }}
            />
            {isOpen && (
                <div
                    className="lightbox-overlay"
                    onClick={() => setIsOpen(false)}
                >
                    <div className="lightbox-content">
                        <button
                            className="lightbox-close"
                            onClick={() => setIsOpen(false)}
                            aria-label="Close"
                        >
                            ×
                        </button>
                        <img src={src} alt={alt} />
                    </div>
                </div>
            )}
        </>
    );
}